import { Address } from 'types/Address';
import { RAI } from 'types/Concessionnaire';

export enum UserRole {
  GROUP_MANAGER = 'GROUP_MANAGER',
  MANAGER = 'MANAGER',
  TECHNICIAN = 'TECHNICIAN',
}

export enum AccessType {
  CLIENT = 'CLIENT',
  SIMULATEUR = 'SIMULATEUR',
  CONCESSIONNAIRE = 'CONCESSIONNAIRE',
}

export interface FicheDeLiaison {
  id: string;
  marque: string;
  rai: RAI;
}

export interface User {
  id: number;
  username: string;
  phone?: string;
  mobilePhone?: string;
  email: string;
  account: {
    name: string;
    siret: string;
    address?: Address;
  };
  confirmed: boolean;
  blocked: boolean;
  firstname: string;
  lastname: string;
  numero_contrat: string;
  raison_sociale_entreprise: string;
  resetPasswordTokenCreatedAt: string | null;
  createdAt: Date;
  updatedAt: Date;
  accessType: AccessType;
  role: UserRole;
  impersonated?: boolean;
  createdBy?: User;
  updatedBy?: User;

  // Utilisé pour les concessionnaires
  contractRAI?: RAI;

  fichesDeLiaison?: FicheDeLiaison[]; // Fiches de liaison (utilisé pour les concessionnaires uniquement)
}

export interface UserOwner {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
}
